
import Vue from 'vue'
import ExpectedTransformer from '@/transformers/workPlan/expected'

export default (opts={}) => {
	let url = 'workplan/expected/'
  const { residentId, finished, cancelToken, dateStart, dateUntil, id } = opts

	if (residentId) {
		url += `resident/${residentId}/`
  } else if (id) {
    url += `${id}/`
  }

  const params = {
    finished: finished ? finished : undefined,
    // :TODO: Remove filtering
    date_start: dateStart ? dateStart : undefined,
    date_until: dateUntil ? dateUntil : undefined,
  }

	return Vue.$http.get(url, { params, cancelToken })
		.then(response => {
      let data
      if (id) {
        data = ExpectedTransformer.fetch(response.data)
      } else {
        data = ExpectedTransformer.fetchCollection(response.data)
          .sort((a, b) => a.dateObjects.startDate - b.dateObjects.startDate)
      }
			return data
		})
}



// WEBPACK FOOTER //
// ./src/services/workPlan/fetchExpected.js